// extracted by mini-css-extract-plugin
export default {"leftPipeDivider":"_99cf8391","originalListPrice":"_9c1dc171"};